import { evaluateOperator } from './operators.js';
import { isOptionsOutcome, isShowOutcome, isSelectElement, } from './types.js';
export const evaluateShowConditionalOutcome = (element, previousElementAnswers) => {
    const showOutcomes = element.conditions?.filter(isShowOutcome) || [];
    if (showOutcomes.length === 0) {
        return true;
    }
    return showOutcomes.some((outcome) => evaluateOperator(outcome.condition, previousElementAnswers));
};
export const evaluateOptionsConditionalOutcomes = (element, previousElementAnswers) => {
    const optionOutcomes = element.conditions?.filter(isOptionsOutcome) || [];
    if (optionOutcomes.length === 0) {
        return null;
    }
    if (!isSelectElement(element)) {
        throw new Error(`Options outcome is only supported on Select elements. Element ${element.id} is not a Select element.`);
    }
    const optionsOverridesValues = new Set(optionOutcomes.flatMap((outcome) => {
        if (evaluateOperator(outcome.condition, previousElementAnswers)) {
            return outcome.outcomeMeta.options;
        }
        return [];
    }));
    const optionsOverrides = element.meta.options.filter((option) => optionsOverridesValues.has(option.value));
    return optionsOverrides;
};
export const getConditionalChanges = (element, previousAnswers) => {
    if (!element.conditions || element.conditions.length === 0) {
        return { visible: true };
    }
    const isVisible = evaluateShowConditionalOutcome(element, previousAnswers);
    if (!isVisible) {
        return { visible: false };
    }
    const optionsOverrides = evaluateOptionsConditionalOutcomes(element, previousAnswers);
    if (optionsOverrides !== null) {
        if (optionsOverrides.length === 0) {
            return { visible: false };
        }
        return {
            visible: true,
            metaOverrides: {
                options: optionsOverrides,
            },
        };
    }
    return { visible: true };
};
